import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propNumber, propBool, } from '../../../../../../helpers/custom-prop-types';
import ProfessionalMyPageTopProffitSearchSlideCount from './ProffitSearchSlideCount';
import ProfessionalMyPageTopProffitSearchSlideTags from './ProffitSearchSlideTags';
/**
 * Proffit Searchのスライド状況を表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ProfessionalMyPageTopProffitSearchSlide = (props) => {
    const { adminFileCount, comparedToLastWeekSlideCount, isFree, myFileCount, tags, } = props;
    return (_jsxs("div", Object.assign({ className: 'professional_mypage_top_proffit_search_slide' }, { children: [_jsx("div", Object.assign({ className: 'slide_count' }, { children: _jsx(ProfessionalMyPageTopProffitSearchSlideCount, { adminFileCount: adminFileCount, comparedToLastWeekSlideCount: comparedToLastWeekSlideCount, isFree: isFree, myFileCount: myFileCount }) })), _jsx("div", Object.assign({ className: 'slide_tags' }, { children: _jsx(ProfessionalMyPageTopProffitSearchSlideTags, { tags: tags }) }))] })));
};
ProfessionalMyPageTopProffitSearchSlide.propTypes = {
    adminFileCount: propNumber(),
    comparedToLastWeekSlideCount: propNumber(),
    isFree: propBool().isRequired,
    myFileCount: propNumber(),
    tags: propArrayShape(),
};
ProfessionalMyPageTopProffitSearchSlide.defaultProps = {
    adminFileCount: undefined,
    comparedToLastWeekSlideCount: undefined,
    myFileCount: undefined,
    tags: null,
};
export default ProfessionalMyPageTopProffitSearchSlide;
